<template>

  <div  dir="ltr">
    <b-dropdown :text="item.name" variant="transparent" class="m-0 p-0"
                v-if="item.children.length!==0">

      <b-nav-item class="px-1 text-decoration-none font-weight-bold"
                  :href="child.url" v-for="child in item.children" :key="child.id">{{child.name}}&MediumSpace;
        <m-icon class="m-0" :icon="child.icon_class"/>
      </b-nav-item>

    </b-dropdown>

    <b-nav-item :href="item.url" class="px-1 text-decoration-none font-weight-bold" v-else>{{ item.name }} &MediumSpace;
      <m-icon class="m-0" :icon="item.icon_class" />
    </b-nav-item>

  </div>

</template>

<script>

export default {
  name: "NavMenuItem",
  props:['item'],
}
</script>

<style scoped>
a{
  text-decoration: none !important;
  color: var(--gray-dark) !important;
}
li{
  list-style: none !important;
}
</style>